<template>
  <div>
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
